/* eslint-disable no-plusplus */
/* eslint-disable import/no-cycle */
import Brand from './brand';
import Category from './category';
import ChainLength from './chainLength';
import ChainType from './chainType';
import Collection from './collection';
import Gem from './gem';
import JewelryType from './jewelryType';
import Metal from './metal';
import Variation from './variation';

class Product {
  constructor({
    id,
    attributes: {
      title,
      description,
      characteristics,
      createdAt,
      updatedAt,
      publishedAt,
      brand,
      categories,
      collection,
      jewelry_type,
      variations,
      is_smart,
    },
  }) {
    if (
      !id ||
      !title ||
      !variations.data.length ||
      // !collection.data ||
      // !jewelry_type.data ||
      !brand.data
    ) {
      return null;
    }
    this.id = id;
    this.title = title;
    this.description = description;
    this.characteristics = characteristics;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.publishedAt = publishedAt;
    this.brand = new Brand(brand.data);
    if (collection?.data) {
      this.collection = new Collection(collection.data);
    }
    if (jewelry_type?.data) {
      this.jewelryType = new JewelryType(jewelry_type.data);
    }
    this.is_smart = is_smart;
    if (categories?.data.length > 0) {
      this.categories = categories.data.map((cat) => new Category(cat));
    }
    this.variations = this.sortVariations(
      variations.data.map((cat) => new Variation(cat, this.jewelryType)),
    );
    if (this.variations.length > 0) {
      this.gems = this.getGemsFromVariations(variations.data);
      this.metals = this.getMetalsFromVariations(variations.data);
      this.chainTypes = this.getChainTypesFromVariations(variations.data);
      this.chainLengths = this.getChainLengthsFromVariations(variations?.data);
      this.setImage();
    }
  }

  sortVariations(variations) {
    const sorted = variations.sort((a, b) => a.wholesalePrice - b.whoselaPrice);
    return sorted;
  }

  getGemsFromVariations(variations) {
    if (variations[0].attributes?.gem?.data) {
      const gems = variations.map((v) =>
        v.attributes.gem.data ? new Gem(v.attributes?.gem?.data) : null,
      );

      const gemsUniq = [];
      gems.filter((item) => {
        const i = gemsUniq.findIndex((x) => x.id === item.id);
        if (i <= -1) {
          gemsUniq.push(item);
        }
        return null;
      });
      return gemsUniq;
    }
    return null;
  }

  getMetalsFromVariations(variations) {
    if (variations[0].attributes?.metal?.data) {
      const arr = variations.map((v) =>
        v.attributes.metal.data ? new Metal(v.attributes.metal.data) : null,
      );
      const arrUniq = [];
      arr.filter((item) => {
        if (item) {
          const i = arrUniq.findIndex((x) => x.id === item.id);
          if (i <= -1) {
            arrUniq.push(item);
          }
        }
        return null;
      });
      return arrUniq;
    }
    return null;
  }

  getChainTypesFromVariations(variations) {
    if (variations[0].attributes?.chain_type?.data) {
      const arr = variations.map((v) =>
        v.attributes.chain_type.data
          ? new ChainType(v.attributes.chain_type.data)
          : null,
      );
      const arrUniq = [];
      arr.filter((item) => {
        if (item) {
          const i = arrUniq.findIndex((x) => x.id === item.id);
          if (i <= -1) {
            arrUniq.push(item);
          }
        }
        return null;
      });
      return arrUniq;
    }
    return null;
  }

  getChainLengthsFromVariations(variations) {
    if (variations[0].attributes?.chain_length?.data) {
      const arr = variations.map((v) =>
        v.attributes.chain_length.data
          ? new ChainLength(v.attributes.chain_length.data)
          : null,
      );
      const arrUniq = [];
      arr.filter((item) => {
        if (item) {
          const i = arrUniq.findIndex((x) => x.id === item.id);
          if (i <= -1) {
            arrUniq.push(item);
          }
        }
        return null;
      });
      return arrUniq;
    }
    return null;
  }

  setImage() {
    let image = null;
    for (let i = 0; i < this.variations.length; i++) {
      if (this.variations[i].image) {
        image = this.variations[i].image;
        break;
      }
    }
    this.image = image;
  }
}

export default Product;
